// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as ListBox from "./ListBox.res.js";
import * as Popover from "../overlays/Popover.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactStately from "react-stately";
import * as InputTextField from "./InputTextField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactDomEventTarget from "../../primitives/ReactDomEventTarget.res.js";

function InputSuggestionComboBoxField(props) {
  let onChange = props.onChange;
  let value = props.value;
  let items = props.items;
  let errorMessage = props.errorMessage;
  let placeholder = props.placeholder;
  let __focused = props.focused;
  let __disabled = props.disabled;
  let label = props.label;
  let disabled = __disabled !== undefined ? __disabled : false;
  let focused = __focused !== undefined ? __focused : false;
  let match = React.useState(() => focused);
  let setFocused = match[1];
  let match$1 = ReactAria.useFilter({
    sensitivity: "base"
  });
  let match$2 = React.useState(() => ListBox.defaultItemsPerScroll);
  let setItemsLimit = match$2[1];
  let triggerRef = React.useRef(null);
  let inputRef = React.useRef(null);
  let popoverRef = React.useRef(null);
  let listBoxRef = React.useRef(null);
  ReactUpdateEffect.use1(() => {
    setFocused(param => focused);
  }, [focused]);
  let children = React.useMemo(() => [JsxRuntime.jsx(ReactStately.Section, {
      children: items.map(item => JsxRuntime.jsx(ReactStately.Item, {
        children: JsxRuntime.jsx("span", {
          children: item.value
        }),
        textValue: item.value
      }, item.value)),
      title: I18n.t("Suggestions")
    })], [items]);
  let onFocusChange = React.useCallback(focused => setFocused(param => focused), []);
  let props_aria$label = label;
  let props_defaultFilter = match$1.contains;
  let props_onInputChange = onChange;
  let props_defaultSelectedKey = value;
  let props_onFocusChange = onFocusChange;
  let props_onFocus = props.onFocus;
  let props_onBlur = props.onBlur;
  let props$1 = {
    children: children,
    "aria-label": props_aria$label,
    isDisabled: disabled,
    placeholder: placeholder,
    defaultFilter: props_defaultFilter,
    allowsCustomValue: true,
    menuTrigger: "input",
    inputValue: value,
    onInputChange: props_onInputChange,
    allowsEmptyCollection: false,
    defaultSelectedKey: props_defaultSelectedKey,
    onFocusChange: props_onFocusChange,
    onFocus: props_onFocus,
    onBlur: props_onBlur
  };
  let state = ReactStately.useComboBoxState(props$1);
  let newrecord = {...props$1};
  let match$3 = ReactAria.useComboBox((newrecord.popoverRef = Primitive_option.some(popoverRef), newrecord.listBoxRef = Primitive_option.some(listBoxRef), newrecord.inputRef = Primitive_option.some(inputRef), newrecord), state);
  let onScroll = React.useCallback(event => {
    let element = ReactDomEventTarget.toUnsafeDomEventTarget(event.currentTarget);
    let scrollHeight = element.scrollHeight;
    let clientHeight = element.clientHeight;
    let scrollOffset = scrollHeight - (clientHeight << 1) | 0;
    if (element.scrollTop > scrollOffset) {
      return setItemsLimit(itemsLimit => itemsLimit + ListBox.defaultItemsPerScroll | 0);
    }
  }, []);
  let openedList = state.isOpen;
  let errored = Stdlib_Option.isSome(errorMessage);
  let hasNoItem = items.length === 0;
  let focused$1 = match[0] || openedList;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(InputTextField.make, {
        variation: {
          NAME: "suggestion",
          VAL: {
            opened: openedList,
            toggleButtonDisabled: hasNoItem,
            toggleButtonProps: match$3.buttonProps,
            onRequestClear: () => onChange("")
          }
        },
        label: label,
        required: props.required,
        disabled: disabled,
        focused: focused$1,
        copyable: false,
        placeholder: placeholder,
        errorMessage: errorMessage,
        containerRef: triggerRef,
        inputRef: inputRef,
        ariaProps: match$3.inputProps
      }),
      openedList ? JsxRuntime.jsx(Popover.make, {
          children: JsxRuntime.jsx(ListBox.make, {
            domRef: listBoxRef,
            state: state,
            props: match$3.listBoxProps,
            itemsLimit: match$2[0],
            onScroll: onScroll
          }),
          popoverRef: popoverRef,
          triggerRef: triggerRef,
          state: {
            isOpen: state.isOpen,
            close: state.close,
            toggle: state.toggle
          },
          layout: "triggerStrictWidth",
          modal: false,
          offset: errored ? -16 : undefined
        }) : null
    ]
  });
}

let make = InputSuggestionComboBoxField;

export {
  make,
}
/* I18n Not a pure module */
